import { Observable } from 'rxjs';
import { InjectionToken } from '../../injection';
import { EmptyResponse } from '../data/empty-response.do';
import { Organization, OrganizationEagerLoad } from '../data/organization.do';
import { PagedResults } from '../data/paged-results.model';
import { Dictionary, ParameterValueType } from '../interfaces/dictionary.interface';
import { FlagsEnum } from '../other/flags-enum';

/**
 * Possible query parameters for Organization service.
 *  @param page Page index.
 *  @param per_page Results per page.
 *  @param filter The search string.
 */
export interface OrganizationQueryParameters extends Dictionary<ParameterValueType> {
  page?: number;
  per_page?: number;
  filter?: string;
  adminDomainId?: string;
}

export interface IOrganizationService {
  /**
   * Saves a new organization.
   */
  createOrganization(organization: Organization): Observable<Organization>;

  /**
   * Deletes an existing organization.
   */
  deleteOrganization(organizationId: string): Observable<EmptyResponse>;

  /**
   * Returns all the retrieved organization for the provided query.
   *
   * @param queryParameters Dictionary containing the query parameters.
   */
  getOrganizations(
    queryParameters: OrganizationQueryParameters,
    eagerLoad?: FlagsEnum<OrganizationEagerLoad>
  ): Observable<PagedResults<Organization>>;

  /**
   * Returns an organization by it's ID.
   */
  getOrganization(organizationId: string, eagerLoad?: FlagsEnum<OrganizationEagerLoad>): Observable<Organization>;

  /**
   * Updates an existing organization.
   */
  updateOrganization(organization: Organization): Observable<Organization>;
}

export const IOrganizationService = new InjectionToken('IOrganizationService');
